import { StyledContainer, StyledIcon, StyledText } from "./diagnosis-loading-styles";

const DiagnosisLoading = () => (
  <StyledContainer>
    <StyledText>Aguarde o seu diagnóstico!</StyledText>
    <StyledIcon />
  </StyledContainer>
);

export default DiagnosisLoading;